import { download, fileIcon } from 'src/pages/DashboardPage/vpo/ui-icons/icons';
import { BACKEND_URL } from '../../api/config';
import { s3cloudUrl } from '../../../../../api/config';

const isCloudLink = (str: string) => {
  return str.includes(s3cloudUrl);
}

type DownloadButtonProps = {
  name: string;
  src: string;
  size: number;
}

function DownloadButton({ name, src, size}: DownloadButtonProps) {
  const handleDownload = () => {
    const url = isCloudLink(src)
      ? `${BACKEND_URL}/${new URL(src).pathname.slice(1)}`
      : `${BACKEND_URL}${src}`;
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <button
      className="flex gap-2 rounded-md bg-gray-100 px-4 py-2"
      type="button"
      onClick={handleDownload}
    >
      <div>
        {fileIcon}
      </div>

      <span>
        {name} ({Math.round(size)}{' '}KB)
      </span>

      <div className="ml-auto">
        {download}
      </div>
    </button>
  )
}

export default DownloadButton;
